<template>
  <div
    v-if="store.state.initiateFlow"
    class="h-full bg-white z-50 overflow-y-auto overflow-x-hidden"
    :class="{ 'pt-16': isMatchingQuizFlow }"
  >
    <wizard-flow
      :flow-name="store.state.initiateFlow"
      :context="store.state.preconditions!"
      @flow-complete="handleFlowComplete"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/modules/wizard/stores/wizard-flows.store'
import WizardFlow from '@/modules/wizard/components/wizard/WizardFlow.vue'
import apiService from '@/services/api.service'
import eebPlacement from '@/services/amplitude/eeb-placement.service'

const router = useRouter()

const isMatchingQuizFlow = computed(
  () => store.state.initiateFlow === 'MatchingQuizFlow',
)

provide('hasOverlayNavbar', isMatchingQuizFlow)

const handleFlowComplete = async () => {
  // EEB Placement Experiment (OCPT-860): variant B finishes onboarding without
  // the EEB booking step. That step used to mark onboarding done on the backend
  // and navigate to ds.home — both are missing here, so we do them explicitly.
  // Otherwise the next `/wizard-flows` fetch re-opens onboarding and the user is
  // left on an empty route after the overlay closes.
  const isOnboardingMainscreenVariant =
    store.state.initiateFlow === 'OnboardingFlow' &&
    eebPlacement.isMainscreenVariant()

  if (isOnboardingMainscreenVariant) {
    try {
      await apiService.wizardFlows.complete('OnboardingFlow')
    } catch (error) {
      console.error('Failed to mark onboarding complete:', error)
    }
  }

  store.clearInitiateFlow()

  if (isOnboardingMainscreenVariant) {
    router.push({ name: 'ds.home' })
  }
}
</script>
